<template>
  <div class="switch-display">
    <vs-switch
      v-model="layer.visible"
      @input="onFirefoxChange(layer)"
      @change="onSwitchChange(layer)"
      :disabled="layer.disabled"
    />
    <div v-if="layer.description">
      <!-- <vs-tooltip :text="layer.description" position="right"> !!BUG in library-->
      <label for class="switch-label" :title="layer.description">
        {{ layer.alias }}
      </label>
      <!-- </vs-tooltip> -->
    </div>
    <label v-else for class="switch-label">{{ layer.alias }}</label>
    <!-- <div v-if="layer.hasFuture" style="margin-left:1rem">
      <label>(Present | Climate Change)</label>
    </div> -->
  </div>
</template>
<script>
export default {
  props: {
    layer: {
      type: Object,
      required: true
    }
  },
  methods: {
    onFirefoxChange(layer) {
      /// Work around for bug with vuex switches in firefox (https://github.com/lusaxweb/vuesax/pull/150)
      if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) {
        this.onSwitchChange(layer);
      }
    },
    onSwitchChange(layer) {
      this.$emit("listenSwitchState", layer);
    }
  }
};
</script>
<style scoped>
.vs-switch {
  min-width: 34px;
  height: 14px;
  transition: margin-left 0.25s ease;
}

.vs-switch >>> .vs-circle-switch {
  width: 10px;
  height: 10px;
  transition: margin-left 0.25s ease;
}

.vs-switch.vs-switch-active >>> .vs-circle-switch {
  margin-left: calc(100% - 14px);
}

.switch-display {
  display: inline-flex;
  padding: 10px;
  font-size: 0.8rem;
}

.switch-label {
  margin-left: 5px;
}
</style>
